export default __webpack_public_path__ + "static/media/cp_httpsi_httpsi.ico.dd60f2b7.svg";